import React from "react";
import { CheckCircle, Circle } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/constants";
import { INVITE } from "@/components/user-wizard/ResendWelcome";

export const onboardingSteps = (u) => {
  const invite = INVITE.includes(u.status);
  return [
    { key: "signed-in", label: "Signed in", done: !!u.last_login_at, at: u.last_login_at, todo: "Hasn't signed in yet" },
    {
      key: "password", label: "Password set", done: !invite && !u.must_change_password,
      at: u.password_changed_at || u.invitation_accepted_at,
      todo: invite ? "Hasn't accepted the invite yet" : "Still on the temporary password",
    },
    { key: "guide", label: "Guide opened", done: !!u.guide_opened_at, at: u.guide_opened_at, todo: "Hasn't opened a guide yet" },
  ];
};

export function OnboardingProgress({ user, testId, className = "flex flex-col gap-0.5" }) {
  const steps = onboardingSteps(user);
  return (
    <div className={className} data-testid={testId} data-done={steps.filter((s) => s.done).length}>
      {steps.map((s) => {
        const Icon = s.done ? CheckCircle : Circle;
        const tip = s.done ? `${s.label}${s.at ? ` ${fmtDate(s.at)}` : ""}` : s.todo;
        return (
          <span key={s.key} title={tip} data-testid={`${testId}-${s.key}`} data-done={s.done ? "yes" : "no"}
            className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-widest whitespace-nowrap ${s.done ? "text-emerald-700" : "text-zinc-500"}`}>
            <Icon size={12} weight={s.done ? "fill" : "regular"} /> {s.label}
          </span>
        );
      })}
    </div>
  );
}
